import gql from 'graphql-tag'

export const USER_DELETE_MUTATION = gql`
    mutation userDelete(
        $id: ID!
    ) {
        userDelete(
            id: $id
        ) {
            status
        }
    }
`
